// default sortingorder of productimages
import { OKVProduct } from 'components/ContentElements/OnlineCatalogAssets/types';

const SORTING = [
  'PrimaryImageJPG',
  'PerspectiveDrawingJPG',
  'TopViewJPG',
  'FrontViewJPG',
  'SideViewJPG',
];

// Sort the images according of the incoming assignment
export function sortProductImages(gallery: OKVProduct['gallery'], sorting = SORTING) {
  // filter right product type
  const thumbnailsProducts = gallery?.list?.filter((item) => item.type === 'IMG_TYPE_Product');
  let thumbnailsArticles = gallery?.list?.filter((item) => item.type === 'IMG_TYPE_Article');

  const productsSorted = sorting
    .map((name) => thumbnailsProducts?.find((item) => item.orientation === name))
    .filter((item) => !!item);

  if (!thumbnailsArticles) thumbnailsArticles = [];

  return [...productsSorted, ...thumbnailsArticles];
}
